import React from "react";
import ProfileForm from "../ProfileForm/ProfileForm";
import BankAccounts from "assets/scripts/components/containers/secure/BankAccounts/BankAccounts";
import { defineMessages } from "react-intl";
export const messages = defineMessages({
    submit: {
        id: "forms.profileEdit.submit",
        defaultMessage: "Save"
    }
});
const ProfileEditForm = ({ updateProfile, ...otherProps }) => (<ProfileForm {...otherProps} onSubmit={updateProfile} submitLabel={messages.submit} enhancedStyles>
		{process.env.FEATURE_SAVE_BANK_INFO && (<div className="form-group">
				<BankAccounts />
			</div>)}
	</ProfileForm>);
export default ProfileEditForm;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileEditForm/ProfileEditForm.tsx